<template>
  <v-expansion-panel v-model="vare" expand class="panel" >
    <v-expansion-panel-content >
      <template v-slot:header >
        <h2>Margens Econômicas</h2>
      </template>

      <v-container white grid-list-md text-xs-center text-md-center >
        <v-layout  justify-center align-center>
          <v-flex xs12 sm12 md6>
            <div class="divider2">
              <span>
                <b>Margem bruta e operacional</b>
              </span>
            </div>
            <v-divider></v-divider>
            <v-card>
              <tab-grafico-margem-bruta-operacional/>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container white grid-list-md text-xs-center text-md-center >
        <v-layout justify-center align-center>
          <v-flex xs12 sm12 md6>
            <div class="divider2">
              <span>
                <b>Lucro e componentes de seu calculo</b>
              </span>
            </div>
            <v-divider></v-divider>
            <v-card>
              <tab-grafico-lucro-componentes-de-seu-calculo/>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>
<script>
import TabGraficoMargemBrutaOperacional from "../tabs/TabGraficoMargemBrutaOperacional.vue";
import TabGraficoLucroComponentesDeSeuCalculo from "../tabs/TabGraficoLucroComponentesDeSeuCalculo.vue";
export default {
  components: {
    "tab-grafico-margem-bruta-operacional": TabGraficoMargemBrutaOperacional,
    "tab-grafico-lucro-componentes-de-seu-calculo": TabGraficoLucroComponentesDeSeuCalculo,
  },
  props: ['vare'],
  data: () => ({
    panel: []
  })
};
</script>
<style scoped>
@media screen and (max-width: 991px) {
  .grafico {
    margin-top: 5%;

    margin-bottom: 3%;
  }

  .panel {
    margin-top: 3%;
    padding-bottom: 3%;
    background-color: white;
    box-shadow: 0 4px 15px black;
  }

  .button {
    margin-top: 5%;
    margin-bottom: 5%;
  }

  .divider2 {
    margin-top: 5%;
    margin-left: 5%;
    font-size: 110%;
  }
}

@media screen and (min-width: 992px) {
  .grafico {
    display: inline-block;
    margin-top: 5%;
    margin-left: 10%;
    margin-right: 1%;
    margin-bottom: 5%;
  }
  .grafico1 {
    display: inline-block;
    margin-top: 2%;
    margin-left: 30%;
    margin-right: 30%;
    margin-bottom: 5%;
  }

  .panel {
    margin-top: 2%;
    padding-bottom: 1%;
    background-color: white;
    box-shadow: 0 4px 10px black;
  }

  .button {
    margin-bottom: 2%;
  }
  .divider2 {
    font-size: 150%;
    margin-top: 5%;
    margin-left: 5%;
  }
}
</style>
